import type { FormDialogModel } from './hooks/useFormDialog';
import type { TabItem } from '@/components/custom/erp';
import { BasicInfoTab } from './BasicInfoTab';
import InfoDropdown from './InfoDropdown';
import { HistoryTab } from './HistoryTab';

export const FormHeader = (dialog: FormDialogModel): TabItem[] => [
  {
    id: 'info',
    label: 'Thông tin',
    component: (
      <div onChange={dialog.markDirty}>
        <BasicInfoTab formMode={dialog.formMode} formState={dialog.formState} />
      </div>
    )
  },
  ...(dialog.formMode === 'view' ? [{ id: 'history', label: 'Lịch sử', component: <HistoryTab /> }] : [])
];

export const FormHeaderActions = ({ dialog }: { dialog: FormDialogModel }) =>
  dialog.formMode !== 'add' ? (
    <InfoDropdown uuid={dialog.initialData?.uuid || ''} ma_ct={dialog.initialData?.chung_tu || undefined} />
  ) : null;
